// Cover art for sessions, sounds and packs without a picture, ported from
// the app's ArtTile: two soft colour glows on `raised`. Two colours per
// tile (decision 34).
import { ACCENT, OTHERS, forName, strHashMod } from "./people.js";

export const RAISED = "#1e1e27";
const ART_POOL = [ACCENT, ...OTHERS];

// Session or loop art: the owner's colour (or the seed's) and the next
// palette colour. Never the same colour twice.
export function seededColors(seed, owner) {
  const a = owner || forName(seed);
  const i = OTHERS.indexOf(a);
  if (i >= 0) return [a, OTHERS[(i + 1) % OTHERS.length]];
  const b = forName(seed);
  return [a, b === a ? OTHERS[0] : b];
}

// Sound and pack art: the owner leads; the second colour is picked by the
// seed from the rest of the pool.
export function pooledColors(seed, owner) {
  const rest = ART_POOL.filter((c) => c !== owner);
  return [owner, rest[strHashMod(seed, rest.length)]];
}

// The boards' CSS: radial-gradient(circle at 30% 35%, a 0, transparent 62%),
// radial-gradient(circle at 72% 68%, b 0, transparent 58%), #1E1E27.
export function artBackground([a, b]) {
  return (
    `radial-gradient(circle at 30% 35%, ${a} 0, transparent 62%), ` +
    `radial-gradient(circle at 72% 68%, ${b} 0, transparent 58%), ${RAISED}`
  );
}

// Corner radius by size (boards: 26 is 5, 36 is 6, 40/44 is 7, 104 is 9,
// 160 to 193 is 10, 210 is 12).
export function radiusFor(size) {
  if (size <= 30) return 5;
  if (size <= 38) return 6;
  if (size <= 60) return 7;
  if (size <= 130) return 9;
  if (size < 200) return 10;
  return 12;
}
